/* F-03 Info: notes beside checklists. */
.page {
  padding-bottom: var(--dimension-space-8);
}
.pad {
  padding: var(--dimension-space-4) var(--dimension-space-5);
}
.flat {
  margin: 0;
}
.muted {
  color: var(--color-text-secondary);
}
.top {
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.notice {
  margin: 0;
  padding: var(--dimension-space-2) var(--dimension-space-5);
  background: var(--color-surface-sunken);
}
.grid {
  display: grid;
  grid-template-columns: 3fr 2fr;
  align-items: start;
}
.grid > section + section {
  border-left: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dimension-space-3) var(--dimension-space-5);
  border-bottom: var(--dimension-line-control) solid var(--color-text-primary);
}
.card {
  display: grid;
  gap: var(--dimension-space-2);
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.editing {
  background: var(--color-surface-raised);
  border-left: var(--dimension-line-accent) solid var(--color-surface-signal);
}
.cardHead {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
}
.spacer {
  flex: 1;
}
.mine {
  padding: 1px var(--dimension-space-1);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
  color: var(--color-text-secondary);
}
.icon {
  border: 0;
  background: none;
  color: var(--color-text-tertiary);
  cursor: pointer;
  padding: var(--dimension-space-1);
}
.icon:hover {
  color: var(--color-text-primary);
}
.body {
  display: grid;
  gap: var(--dimension-space-1);
}
.body a {
  color: inherit;
}
.bullet::before {
  content: "• ";
}
.check {
  display: flex;
  align-items: baseline;
  gap: var(--dimension-space-2);
  cursor: pointer;
}
.done {
  color: var(--color-text-secondary);
  text-decoration: line-through;
}
.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: var(--dimension-space-1);
}
.tool {
  display: grid;
  place-items: center;
  width: 32px;
  height: 28px;
  border: 0;
  border-radius: var(--dimension-radius-xs);
  background: var(--color-surface-sunken);
  color: var(--color-text-primary);
  cursor: pointer;
}
.linkPick {
  height: 28px;
  border: var(--dimension-line-hairline) solid var(--color-border-control);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
}
.area {
  min-height: 200px;
  padding: var(--dimension-space-2);
  resize: vertical;
  color: var(--color-text-primary);
  background: var(--color-surface-base);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
}
.versions {
  display: grid;
  gap: var(--dimension-space-2);
  max-height: 50vh;
  overflow: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}
.preview {
  margin: 0;
  white-space: pre-wrap;
}
.entries {
  margin: 0;
  padding: 0;
  list-style: none;
}
.entries li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dimension-space-1) 0;
}
.addEntry {
  display: flex;
}
.addEntry input {
  flex: 1;
}
@media (max-width: 899px) {
  .grid {
    grid-template-columns: 1fr;
  }
  .grid > section + section {
    border-left: 0;
  }
}
.check input {
  accent-color: var(--color-text-primary);
}
.entries li .icon {
  opacity: 0;
}
.entries li:hover .icon,
.entries li:focus-within .icon {
  opacity: 1;
}
